import { css } from 'styled-components';
import { CFBaseButtonHelpers } from './styles';
//
// Element Styles
//
export const CFBaseButtonStyles = {
    Label: css `
    color: ${CFBaseButtonHelpers.labelColor};
    ${CFBaseButtonHelpers.labelTypeSpec};
    ${CFBaseButtonHelpers.labelAlignment};
  `,
    LabelNativeInteractions: css `
    ${CFBaseButtonHelpers.interactionsLabelNative};
  `,
    LabelWebInteractions: css `
    ${CFBaseButtonHelpers.interactionsLabelWeb};
  `,
    Root: css `
    position: relative;
    background-color: ${CFBaseButtonHelpers.rootBackgroundColor};
    border-radius: ${CFBaseButtonHelpers.rootBorderRadius}px;
    text-decoration: none;
    cursor: pointer;

    ${CFBaseButtonHelpers.rootBorder};
    ${CFBaseButtonHelpers.rootBoxStyles};
    ${CFBaseButtonHelpers.rootShadow};
  `,
    RootNativeInteractions: css `
    ${CFBaseButtonHelpers.rootNativeInteractions}
  `,
    RootWebInteractions: css `
    cursor: pointer;
    ${CFBaseButtonHelpers.rootWebInteractions}
  `,
    Wrapper: css `
    box-sizing: border-box;
    padding: 0;
    display: flex;
    background: transparent;
    border: 0;
    ${CFBaseButtonHelpers.wrapperWidth};
    ${CFBaseButtonHelpers.wrapperInteractions};
  `,
};
